var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-tabbar',{attrs:{"route":""}},[_c('van-tabbar-item',{attrs:{"replace":"","to":"/home","icon":"wap-home-o"}},[_vm._v("首页")]),_c('van-tabbar-item',{attrs:{"replace":"","to":"/mine","icon":"user-o"}},[_vm._v("我的")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }